import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SprinklerProjectionReport } from './SprinklerProjectionReport';
const queryClient = new QueryClient();
export default function SprinklerProjection() {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(SprinklerProjectionReport, null)));
}
